import React from "react";
import * as Funciones from "../../../../utils/funciones";
import styles from "./tabla-proyecciones-ap.module.css"

const TablaProyeccionesAP = ({ proyecciones, moneda }) => {
    return (
        <div className={styles.contenedor}>
            <div className={styles.gridHeader}>
                <div className={styles.ghAnio}>
                    Año
                </div>
                <div className={styles.ghEdad}>
                    Edad
                </div>
                <div className={styles.ghMontoPagado}>
                    Prima Acumulada
                </div>
                <div className={styles.ghPorcentajeRetiro}>
                    Retiro (%)
                </div>
                <div className={styles.ghRetiro}>
                    Retiro
                </div>
            </div>
            
            <div className={styles.body}>
                {proyecciones !== undefined && proyecciones.length > 0
                    ? Funciones.ordenarListaXCampo(true, proyecciones.filter(proyeccionAux => proyeccionAux.anio !== 999), 'anio')
                        .map((proyeccion, index) => (
                        <div key={'proyeccion_ap_' + index} className={styles.gridBody}>
                            <div className={styles.gbAnio}>
                                {proyeccion.anio}
                            </div>
                            <div className={styles.gbEdad}>
                                {proyeccion.edad}
                            </div>
                            <div className={styles.gbMontoPagado}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.primaAcumulada, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbPorcentajeRetiro}>
                                {proyeccion.porcentajeRetiro}%
                            </div>
                            <div className={styles.gbRetiro}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.montoRetiro, moneda.codigo, true)}
                            </div>
                        </div>
                    ))
                    : <div className={styles.label_no_data}>
                        <div className={styles.label_no_data_span}>No se encontraron registros.</div>
                    </div>
                }
            </div>
        </div>
    )
}

export default TablaProyeccionesAP;